import { http, HttpResponse } from 'msw'

import { allProductCategories } from 'app/mocks/data/catalogue/products/categories'

import { api } from 'app/utils/constants'

import { CategoryProductRequest } from 'app/types/catalogue/product/category'

export const getAllCategoriesProduct = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.catalogue.products.categories.LIST}`,
    () => {
        return HttpResponse.json<CategoryProductRequest>({
            results: allProductCategories,
        })
    },
)
